import './thefifth4insta/style';
import FormStructure from './thefifth4insta/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/kevin/projects/inquiry-renderer/client_forms/includes.js